var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"font-weight-bold mt-6 text--accent-1"},[_vm._v(" "+_vm._s(_vm.title.toUpperCase())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }